module.exports = __webpack_public_path__ + "static/media/al-azhar-180x180.fe29d890.png";